/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const getCollectionChallengeIdsResponseDataSchema = z.array(z.number());

export const getCollectionChallengeIdsResponseSchema = createApiResponseSchema(
  getCollectionChallengeIdsResponseDataSchema,
) as z.ZodSchema<IAPI<number[]>>;

export type IGetCollectionChallengeIdsResponse = IAPI<number[]>;
